import "./App.css";
import Navibar from "./components/navigationbar/navigationbar";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Animation from "./view/pages/animation";
import Page from "./view/page";
import Qr from "../src/Assets/image/download.png";
import FPage from "./view/fiestpage";
import CareerJoin from "./view/pages/careerJoin/careerjoin";
import AboutUs from "./view/pages/Aboutus/aboutus";
import ContactUs from "./view/pages/Contactus/Contactus";
import Fontpage from "./view/pages/fontpage/fontpage";
import Products from "./view/pages/products/products";
import ProductDetails from "./view/pages/products/ProductDetails/productDetails";
import Support from "./view/pages/Support/support";
import Casestudy from "./view/pages/CaseStudy/casestudy";
import Contact_Us from "./view/pages/Contactus/Contactus1";
import Solution from "./view/pages/solution/solution";
import logo from "../src/Assets/image/logo.png";
import chatbot from "../src/icons/chatbot-png.png";
import { motion } from "framer-motion";
import logoMy from "../src/icons/logo.png";
import { CHAT_BASEURL } from "../src/constant/constant";
import { Tooltip, Button } from "@nextui-org/react";
import React, { useEffect, useRef, useState } from "react";
import "./components/chatbot/chatbot.css";
import SearchDetails from "./view/pages/products/searchDetails";
import ApplyNowForm from "../src/Modal/Application_Form";
import BlogPage from "./view/pages/Blogs/Blogs";
import CustomerStories from "./view/pages/CustomerStories/CustomerStories";
import EventsPage from "./view/pages/Events/Events";
import PrivacyPolicy from "./view/pages/PrivacyPolicy/PrivacyPolicy";
import ToolsSoftware from "./view/pages/toolsASoftware/toolsSoftware";
import HeaderLayout from "./components/layout/Headerlayout";
import FAQ from "./view/pages/FAQ/faq";
import WhyUs from "./view/pages/WhyUs/whyus";
import FeaturesPage from "./view/pages/FeaturesPage/FeaturesPage";
import OurStory from "./view/pages/OurStory/OurStory";
import TermsOfUse from "./view/pages/TermsAndConditions/TermsAndConditions";
import BlogDetail from "./view/pages/Blogs/BlogDetail/BlogDetail";
import ProductSubCategory from "./view/pages/products/ProductSubCategory/page";

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [inquiryPromptActive, setInquiryPromptActive] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const chatRef = useRef(null);
  const chatBoxRef = useRef(null);

  const getISTTimestamp = () => {
    return new Date().toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  };

  useEffect(() => {
    if (chatBoxRef.current) {
      const el = chatBoxRef.current;
      el.scrollTop = el.scrollHeight;
    }
  }, [messages]);

  const didGreetRef = useRef(false);

  useEffect(() => {
    if (didGreetRef.current) return; // already greeted (handles StrictMode)
    didGreetRef.current = true;
    appendMessage("Bot", "Hello! How can I help you today?");
  }, []);

  const appendMessage = (sender, text) => {
    const timestamp = getISTTimestamp();
    setMessages((prev) => [...prev, { sender, text, timestamp }]);
  };

  const parseMessage = (message) => {
    const linkRegex = /<a.*?href=['"](.*?)['"].*?>(.*?)<\/a>/g;
    return message.replace(linkRegex, (_, url, text) => {
      return `<a href="${url}" target="_blank" style="color:blue; text-decoration:none;">${text}</a>`;
    });
  }
  useEffect(() => {
    if (!isChatOpen) return;

    const handleClickOutside = (e) => {
      if (chatRef.current && chatRef.current.contains(e.target)) return;
      if (e.target.closest(".floating-btn")) return;
      setIsChatOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isChatOpen]);

  const sendMessage = async (e) => {
    e.preventDefault();
    const userInput = input.trim();
    if (!userInput || isLoading) return;
    if (!isChatOpen) setIsChatOpen(true);
    appendMessage("You", userInput);
    if (inquiryPromptActive && userInput.toLowerCase() === "yes") {
      setInquiryPromptActive(false);
    }
    setInput("");
    setIsLoading(true);
    appendMessage("Bot", "Typing...");

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("X-API-Key", "key_your_gateway_api_key");

      const raw = JSON.stringify({
        data: {
          question: userInput,
        },
        headers: {
          Authorization: "Bearer Nw_bw0e3_9dwSTzxavWFM58zVM7sQuGcEiVWoXFiz4o",
        },
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "https://maingate.seaiot.in/api/external/ai/chatbot",
        requestOptions
      );

      // Parse JSON, not text
      const data = await response.json();

      // Remove "Typing..."
      setMessages((prev) => prev.slice(0, -1));

      // Use only `text` field
      let botMessage = data?.text || "Sorry, I didn’t understand that.";
      botMessage = parseMessage(botMessage);

      if (botMessage.includes("[SHOW_INQUIRY_FORM]")) {
        botMessage = botMessage.replace("[SHOW_INQUIRY_FORM]", "").trim();
        appendMessage("Bot", botMessage);
        appendMessage("Bot", "Would you like to submit an inquiry? (yes/no)");
        setInquiryPromptActive(true);
      } else {
        appendMessage("Bot", botMessage);
        setInquiryPromptActive(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      setMessages((prev) => prev.slice(0, -1));
      appendMessage("Bot", "Sorry, something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      {/* <Navibar /> */}
      <div className="page-container">
        <Routes>
          <Route path="/" element={<FPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact_Us />} />
          <Route path="/font" element={<Fontpage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/support" element={<Support />} />
          <Route path="/casestudy" element={<Casestudy />} />
          <Route path="/solution" element={<Solution />} />
          <Route element={<HeaderLayout />}>
            <Route path="/customerstories" element={<CustomerStories />} />
            <Route path="/Application_Form" element={<ApplyNowForm />} />
            <Route path="/blogPage" element={<BlogPage />} />
            <Route path="/eventsPage" element={<EventsPage />} />
            <Route path="/ProductSubCategory/:slug" element={<ProductSubCategory />} />
            <Route path="/productdetails/:slug/:sub_category_slug" element={<ProductDetails />} />
            <Route
              path="/searchdetails/:slug/:sub_slug"
              element={<SearchDetails />}
            />
            <Route path="/career" element={<CareerJoin />} />
            <Route path="/featuresPage" element={<FeaturesPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/OurStory" element={<OurStory />} />
            <Route path="/WhyUs" element={<WhyUs />} />
            <Route path="/ToolsSoftware" element={<ToolsSoftware />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/TermsOfUse" element={<TermsOfUse />} />
          </Route>
        </Routes>

        {/* Floating Chatbot Button */}
        <div className="floating-btn">
          <div className="tooltip-container">
            <span className="text">
              <motion.div
                whileTap={{ scale: 1.2 }}
                whileHover={{ scale: 1.4 }}
                onClick={() => setIsChatOpen((prev) => !prev)}
              >
                <img src={chatbot} height={52} width={52} alt="Chatbot Icon" />
              </motion.div>
            </span>
          </div>
        </div>

        {/* WhatsApp Button */}
        <div className="floating-btn-first">
          <motion.div
            whileTap={{ scale: 1.2 }}
            whileHover={{ scale: 1.2 }}
            onClick={() => {
              const phone = "918055607812"; // country code + number
              const message = encodeURIComponent(
                `Hello 👋
I visited the website of Sandip Electronics And Automation and would like to know more about your products and services.
Please share the details.`
              );
              window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="tooltip-container-f">
              <span className="">
                <svg
                  viewBox="0 -1 15 19"
                  className="bi bi-whatsapp"
                  fill="#25D366"
                  height="30"
                  width="30"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                </svg>
              </span>
            </div>
          </motion.div>
        </div>

        {/* Chatbot Card */}
        <motion.div
          ref={chatRef}
          className="chat-container"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={
            isChatOpen
              ? { opacity: 1, scale: 1 }
              : { opacity: 0, scale: 0.8, pointerEvents: "none" }
          }
          transition={{ duration: 0.25 }}
        >
          <div className="chat-header">
            <span className="flex justify-center text-center">
              <img src={logoMy} alt="Logo" width={40} height={40} />
            </span>
            <Button className="close-btn" onClick={() => setIsChatOpen(false)}>
              ×
            </Button>
          </div>
          <div className="chat-box" ref={chatBoxRef}>
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message ${msg.sender === "You" ? "sent" : "received"}`}
              >
                <span dangerouslySetInnerHTML={{ __html: msg.text }} />
                <div className="timestamp">{msg.timestamp}</div>
              </div>
            ))}
            {isLoading && (
              <div className="message received">
                <div className="typing-indicator">
                  <span></span><span></span><span></span>
                </div>
              </div>
            )}
          </div>
          <form className="chat-form" onSubmit={sendMessage}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder={isLoading ? "Bot is typing..." : "Type a message..."}
              disabled={isLoading}
              required
            />
            <Button type="submit">Send</Button>
          </form>
        </motion.div>
      </div>
    </>
  );
}

export default App;
